import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const CreditMonitoringCompany = (props) => (
	<ThemeContext.Provider value={{ linkText: "Visit Website" }}>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
